import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/libur-nasional/$year")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/en/public-holidays/${params.year}` } as any);
  },
  component: () => null,
});
